import React from "react";
import { PenLine, Send } from "lucide-react";

export default function BlogEditorActions({ onSaveDraft, onPublish }) {
  return (
    <div className="flex items-center justify-center gap-4 py-6">
      <button
        type="button"
        onClick={onSaveDraft}
        className="inline-flex items-center gap-2 border border-slate-200 text-slate-700 font-semibold text-sm px-6 py-3 rounded-full hover:bg-slate-50 active:scale-[0.98] transition-all duration-200"
      >
        <PenLine className="w-4 h-4" />
        Save Draft
      </button>
      <button
        type="button"
        onClick={onPublish}
        className="inline-flex items-center gap-2 bg-[#7209B7] text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#5a07a0] active:scale-[0.98] transition-all duration-200"
      >
        <Send className="w-4 h-4" />
        Publish Blog
      </button>
    </div>
  );
}
